<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="选择渠道">
              <a-select
                v-model="queryParam.channelCode"
                placeholder="请选择渠道"
                style="width: 200px;margin-left: auto"
                @change="handleChange"
              >
                <a-select-option
                  v-for="item in channelList"
                  :key="item.code"
                  :value="item.code"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
              <!-- <a-select v-model="channelKey" placeholder="请选择渠道">
                <a-select-option v-for="(item,index) in channelList" :key="index" >{{item.name}}</a-select-option>
              </a-select> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAddValue(queryParam.channelCode)"
        >新增分组</a-button
      >
      <!-- <a-button @click="refreshClick(queryParam.channelCode)">刷新</a-button> -->

      <a-button @click="selectClisk">筛选</a-button>

      <a-modal v-model="selVisible" title="筛选" width="920px">
        <template slot="footer">
          <a-button key="back" @click="reactClick">
            重置
          </a-button>
          <a-button key="submit" type="primary" @click="secConfirm">
            搜索
          </a-button>
        </template>
        <a-form layout="inline" ref="searchForm">
          <a-row :gutter="24">
            <a-col :md="8" :sm="8">
              <a-form-item label="分组名称">
                <a-input
                  style="width: 160px;margin-left: auto"
                  placeholder="输入名字模糊查询"
                  v-model="queryParam.groupName"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="8">
              <a-form-item label="分组类型">
                <a-select
                  placeholder="请选择分组类型"
                  style="width: 160px;margin-left: auto"
                  @change="handleChange"
                  v-model="queryParam.groupType"
                >
                  <a-select-option
                    v-for="item in groupType"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="8">
              <a-form-item label="分组人数">
                <a-input
                  oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                  style="width: 70px;margin-left: auto"
                  placeholder="请输入人数范围"
                  v-model="queryParam.countStrart"
                ></a-input>
                <a>~</a>
                <a-input
                  oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                  style="width: 70px;margin-left: auto"
                  placeholder="请输入人数范围"
                  v-model="queryParam.countEnd"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <!-- <a-popconfirm arrowPointAtCenter  placement="bottom" ok-text="搜索" cancel-text="重置" @cancel="cancel" @confirm="confirm">

        <a-icon slot="icon" type="question-circle-o" style="color: red" />
        <a-button @click="selectClisk" >筛选</a-button>
      </a-popconfirm> -->
      <!-- <a-button @click="selectClisk" >筛选</a-button> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        :scroll="{ x: 1500 }"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="typeslot" slot-scope="text, record">
          <span v-if="record.groupType === 1">动态分组</span>
          <span v-if="record.groupType === 0">静态分组</span>
        </template>

        <template slot="syncslot" slot-scope="text, record">
          <span v-if="record.syncTagFlag === 1">是</span>
          <span v-if="record.syncTagFlag === 0">否</span>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handViewList(record)">查看</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">修改</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record.id)">删除</a>
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">删除 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </a-table>
    </div>

    <userConModal ref="modalForm" @ok="handleOk"></userConModal>
    <userListModal ref="listModal"></userListModal>
    <!-- 分组区域END -->
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import userListModal from './modules/userListModal.vue';
import JInput from '@/components/jeecg/JInput';
import userConModal from './modules/userModal.vue';
import { getAction, postAction, downFile, downloadFile } from '@/api/manage';

export default {
  name: 'userConList',
  components: {
    JInput,
    userConModal,
    userListModal
  },
  data() {
    return {
      channelInfo: {},
      loading: false,
      dataSource: [],
      selectedRowKeys: [],
      description: '用户分组管理页面',
      channelList: [],
      groupId: '',
      channelKey: ' ', //所选择的下标
      isAddWin: false, //新增弹窗是否显示
      selVisible: false,
      userList: [],
      queryParam: {
        channelCode: ''
      },
      channelInfo: {},
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      userPageIndex: 1,
      userPageSize: 4,
      groupType: [
        {
          id: 1,
          name: '动态分组'
        },
        {
          id: 2,
          name: '静态分组'
        }
      ],
      // 表头
      columns: [
        {
          title: '分组ID',
          align: 'center',
          dataIndex: 'id'
        },
        {
          title: '分组名称',
          align: 'center',
          dataIndex: 'groupName'
        },
        {
          title: '分组描述',
          align: 'center',
          dataIndex: 'groupDesc'
        },
        {
          title: '分组类型',
          align: 'center',
          dataIndex: 'groupType',
          scopedSlots: { customRender: 'typeslot' }
        },
        {
          title: '分组人数',
          align: 'center',
          dataIndex: 'count'
        },
        {
          title: '是否同步至标签',
          align: 'center',
          dataIndex: 'syncTagFlag',
          scopedSlots: { customRender: 'syncslot' }
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/list',
        delete: process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/deleteBatch',
        exportXlsUrl: process.env.VUE_APP_CMS_WECHAT + '/wechatUser/exportXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_WECHAT + '/wechatUser/importExcel'
      },
      dictOptions: {}
    };
  },
  created() {
    this.getChannelAll();
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
    exportXlsUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.exportXlsUrl}`;
    }
  },
  directives: {
    positiveInt: {
      bind: function(el) {
        el.handler = function() {
          el.value = Number(el.value.replace(/\D+/, ''));
        };
        el.addEventListener('input', el.handler);
      },
      unbind: function(el) {
        el.removeEventListener('input', el.handler);
      }
    }
  },

  methods: {
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList(1);
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    handleAddValue(record) {
      this.$refs.modalForm.add(record);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit: function(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    searchQuery() {
      this.getList();
    },
    handViewList(record) {
      console.warn('11111');
      this.$refs.listModal.handView(record, this.queryParam, this.channelInfo);
    },
    getList(arg) {
      if (arg) {
        this.ipagination.current = arg;
      }
      let page = {
        pageSize: this.ipagination.pageSize,
        pageNo: this.ipagination.current
      };
      let params = Object.assign(this.queryParam, page);
      this.loading = true;
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          this.dataSource =
            res.result.records && res.result ? res.result.records : [];
          this.loading = false;
          this.ipagination.total = res.result.total;
        }
      });
    },

    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      this.ipagination = pagination;
      this.getList({
        pageNo: pagination.current,
        pageSize: pagination.pageSize
      });
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //清空选中的数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    getChannelAll() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/queryAll',
        {}
      ).then(res => {
        if (res.success) {
          this.queryParam.channelCode = res.result[0].code;
          this.channelList = res.result;
          this.$nextTick(() => {
            this.getList();
            this.getChannelInfo(res.result[0].code);
          });
        }
      });
    },
    //获取渠道信息
    getChannelInfo(item) {
      getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/queryByCode', {
        code: item
      }).then(res => {
        if (res.success) {
          this.channelInfo = res.result;
        }
      });
    },
    handleChange(item) {
      //渠道下拉框选择
      // console.log(item);
      this.getChannelInfo(item);

      this.queryParam.channelCode = item;
      this.getList();
    },
    // handleAdd(){//新增
    //   this.isAddWin = true;
    // },
    refreshClick(channelCode) {
      //刷新按钮点击
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/trendsRefresh', {
        channelCode: channelCode
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
      console.log('刷新按钮点击');
    },
    reactClick() {
      //重置
      const channelCode = this.queryParam.channelCode;

      this.queryParam = {
        channelCode
      };

      this.getList();
    },
    selectClisk() {
      //筛选按钮点击
      if (!this.queryParam.channelCode) {
        this.$message.warning('请选择渠道');
      } else {
        this.selVisible = true;
      }
    },
    handleOk(res) {
      console.log(res);
      this.getList();
    },
    secConfirm() {
      //搜索
      if (this.queryParam.countStrart > this.queryParam.countEnd) {
        this.$message.warning('输入范围有误');
      } else {
        this.getList();
        this.selVisible = false;
      }
    },

    handleDelete(id) {
      //删除数据
      console.log(this.url.delete);
      postAction(this.url.delete, { id: id })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
            // this.onClearSelected();
            this.getList();
          } else {
            this.$message.warning(res.message);
          }
        })
        .finally(() => {
          this.getList();
        });
    },

    //标签名称
    getTagName(tagidList) {
      let userTag = tagidList
        .split('[')[1]
        .split(']')[0]
        .split(',');
      let userTagContent = '';
      for (let i in userTag) {
        for (let j in this.tagListAll) {
          if (userTag[i] == this.tagListAll[j].id) {
            userTagContent += this.tagListAll[j].name + ',';
          }
        }
      }
      if (userTagContent.length > 0) {
        userTagContent = userTagContent.substr(0, userTagContent.length - 1);
      }
      return userTagContent;
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
